module.exports = __webpack_public_path__ + "img/01_1986_iPad_P.e5f75266.jpg";